/* eslint-disable import/prefer-default-export */
import React from "react";
import { FORM_BUILDER_FIELD_TYPE, LabelText } from "@loanbossinc/component-library";
import { defaultField, formatDate } from "helpers/row-logic-helper";
import moment from "moment";

import { shouldShowPrincipalReduction, shouldShowAmortizationTerm, shouldShowAmortizationRate } from "./section-loan-extension-rows-logic";

export const rows = (index, isQuote, startSave, goBack) => ({
  title: {
    label: "Extensions",
    isTitle: true,
    buttonLabel: "Remove",
    onTitleButtonClick: data => {
      const current = data.values;
      current.extensions = current.extensions.filter(x => x.id !== current.extensions[index].id);
      startSave(current, goBack);
    },
    titleButtonStyle: { color: "#C40A0A", float: "right" }
  },
  startDate: {
    label: "Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: `extensions[${index}].extensionStart`,
        variant: "filled"
      }
    ]
  },
  endDate: {
    label: "End Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: `extensions[${index}].extensionEnd`,
        variant: "filled"
      }
    ]
  },
  noticeMin: {
    label: "Notice Min",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: `extensions[${index}].extensionNoticeMin`,
        variant: "filled",
        onClientChange: (value, formik) => {
          const record = formik.values.extensions[`${index}`];
          if (!record) {
            return null;
          }
          if (record.extensionStart) {
            if (!value || Number.isNaN(Number(value))) {
              value = 0;
              formik.setFieldValue(`extensions[${index}].extensionNoticeMin`, 0);
            }

            const newDate = moment(record.extensionStart).add(-(Number(value)), "days");
            formik.setFieldValue(`extensions[${index}].extensionNoticeMinDate`, newDate || "");
          }
        },
        getSubText: formik => {
          const selectedExtension = formik.values.extensions[`${index}`];
          if (!selectedExtension) {
            return null;
          }
          let date = null;
          if (selectedExtension.extensionNoticeMinDate) {
            date = selectedExtension.extensionNoticeMinDate;
          } else {
            date = selectedExtension.extensionStart;
          }
          if (selectedExtension.extensionNoticeMin === "") {
            date = selectedExtension.extensionStart;
          }
          const newDate = moment(date).format("MM/DD/YYYY");
          const text = `Due by ${newDate}`;

          return (<>
            <br />
            <LabelText value={text} />
                  </>);
        }
      }
    ]
  },
  noticeMax: {
    label: "Notice Max",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: `extensions[${index}].extensionNoticeMax`,
        variant: "filled",
        onClientChange: (value, formik) => {
          const record = formik.values.extensions[`${index}`];
          if (!record) {
            return null;
          }
          if (record.extensionStart) {
            if (!value || Number.isNaN(Number(value))) {
              value = 0;
              formik.setFieldValue(`extensions[${index}].extensionNoticeMax`, 0);
            }

            const newDate = moment(record.extensionStart).add(-(Number(value)), "days");
            formik.setFieldValue(`extensions[${index}].extensionNoticeMaxDate`, newDate || "");
          }
        },
        getSubText: formik => {
          const selectedExtension = formik.values.extensions[`${index}`];
          if (!selectedExtension) {
            return null;
          }
          let date = null;
          if (selectedExtension.extensionNoticeMaxDate) {
            date = selectedExtension.extensionNoticeMaxDate;
          } else {
            date = selectedExtension.extensionEnd;
          }
          if (selectedExtension.extensionNoticeMax === "") {
            date = selectedExtension.extensionEnd;
          }
          const newDate = moment(date).format("MM/DD/YYYY");
          const text = `Can Submit on ${newDate}`;

          return (<>
            <br />
            <LabelText value={text} />
                  </>);
        }
      }
    ]
  },
  minimumQualificationsHeader: {
    label: "Minimum Qualifications",
    isTitle: true
  },
  ltv: {
    label: "LTV",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: `extensions[${index}].extensionLtv`,
        variant: "filled",
        decimals: 2
      }
    ]
  },
  dscr: {
    label: "DSCR",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: `extensions[${index}].extensionDscr`,
        variant: "filled",
        decimals: 2
      }
    ]
  },
  debtYield: {
    label: "Debt Yield",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: `extensions[${index}].extensionDebtYield`,
        variant: "filled",
        decimals: 3
      }
    ]
  },
  amortizationHeader: {
    label: "Amortization",
    isTitle: true
  },
  amortizationType: {
    label: "Amortization Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: `extensions[${index}].extensionAmortizationTypeId`,
        parentId: "amortizationTypes",
        variant: "filled",
        displayWith: option => option.name,
        setValueWith: option => option.id
      }
    ]
  },
  amortizationRate: {
    isVisible: data => shouldShowAmortizationRate(data.extensions[index], data.details),
    label: "Amortization Rate",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: `extensions[${index}].extensionAmortizationRate`,
        variant: "filled",
        decimals: 3
      }
    ]
  },
  amortizationTerm: {
    isVisible: data => shouldShowAmortizationTerm(data.extensions[index]),
    label: "Amortization Term",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: `extensions[${index}].extensionAmortizationTerm`,
        variant: "filled"
      }
    ]
  },
  principalReduction: {
    isVisible: data => shouldShowPrincipalReduction(data.extensions[index]),
    label: "Principal Reduction",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: `extensions[${index}].extensionAmortizationPrincipalReduction`,
        variant: "filled"
      }
    ]
  },
  feesAndMiscHeader: {
    label: "Fees and misc",
    isTitle: true
  },
  extensionFee: {
    label: "Extension Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: `extensions[${index}].extensionFee`,
        variant: "filled",
        decimals: 3
      }
    ]
  },
  qualificaitons: {
    label: "Qualifications",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: `extensions[${index}].extensionQualifications`,
        variant: "filled",
        multiline: true,
        style: { width: "100%" }
      }
    ]
  },
  extensionMisc: {
    label: "Misc",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: `extensions[${index}].extensionMisc`,
        variant: "filled",
        multiline: true,
        style: { width: "100%" }
      }
    ]
  }
});
